import {Link} from "react-router-dom";
import type {Category, I18nKey, Product} from "@zaaaz/shared";
import {ProductCard} from "./ProductCard";
import {useI18n} from "./I18nProvider";

export type HubSection = {category: Category; items: Product[]; allUrl: string};

type Props = {
  variant: "new" | "best";
  titleKey: I18nKey;
  eyebrowKey: I18nKey;
  leadKey: I18nKey;
  sections: HubSection[];
  loading: boolean;
};

export function CategoryProductHub({variant, titleKey, sections, loading}: Props) {
  const {t} = useI18n();
  const productCount = sections.reduce((n, row) => n + row.items.length, 0);
  if(loading) {
    return (
      <div className={`cc-newHub cc-newHub--${variant} cc-newHub--loading`}>
        <div className="cc-newHub__hero cc-newHub__hero--skeleton" />
        <div className="cc-newHub__body">
          {Array.from({length: 3}).map((_, i) => <div key={i} className="cc-newHub__sectionSkeleton" />)}
        </div>
      </div>
    );
  }
  return (
    <div className={`cc-newHub cc-newHub--${variant}`}>
      <header className="cc-newHub__hero">
        <div className="cc-newHub__heroInner">
          <div className="cc-newHub__heroCopy">
            <h1 className="cc-newHub__title">{t(titleKey)}</h1>
            <p className="cc-newHub__lead">{productCount} {t("products")}</p>
          </div>
        </div>
      </header>
      <div className="cc-newHub__body">
        {!sections.length ? <div className="notfound cc-newHub__empty">{t("No products found")}</div> : null}
        {sections.map((section, index) => (
          <section key={section.category.id} className="cc-newHub__section">
            <span className="cc-newHub__watermark" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            <div className="cc-newHub__sectionHead">
              <div className="cc-newHub__sectionMeta">
                <h2 className="cc-newHub__sectionTitle">
                  <Link to={section.allUrl}>{section.category.nume}</Link>
                </h2>
                <span className="cc-newHub__sectionRule" aria-hidden="true" />
                <span className="cc-newHub__sectionCount">{section.items.length}</span>
              </div>
              <Link to={section.allUrl} className="cc-newHub__seeAll">
                {t("See all")} <i className="fa fa-angle-right" aria-hidden="true" />
              </Link>
            </div>
            <div className="cc-productGridWrap">
              <div className="cc-productGrid cc-productGrid--hub">
                {section.items.map((p) => <ProductCard key={`${section.category.id}-${p.id}`} product={p} showWishlist />)}
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
